module.exports = __webpack_public_path__ + "img/constellaDrps.3f26822.svg";